import { ImageContent } from '../types/contentful/Atoms/ImageContent';
import { ContentBodyModels } from '../components/organisms/ContentBody';
import { extractTextFromRichText } from './richText';

export const extractFirstImageFromContentBody = (
  body: ContentBodyModels[]
): ImageContent | null => {
  const firstImageSection = body.find(
    (item) =>
      item.__typename === 'GroupedImagesSection' ||
      item.__typename === 'VideoSection'
  );
  if (firstImageSection?.__typename === 'GroupedImagesSection') {
    return firstImageSection.images.at(0) ?? null;
  }
  if (firstImageSection?.__typename === 'VideoSection') {
    return firstImageSection.fallbackImage ?? null;
  }
  return null;
};

export const extractTextFromContentBody = (
  body: ContentBodyModels[]
): string[] | null => {
  const firstText = body.find((item) => item.__typename === 'RichText');
  if (firstText?.__typename === 'RichText') {
    const text = extractTextFromRichText(firstText.text);
    return text;
  }

  return null;
};
